module.exports = require("localforage");